var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#EAFFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3288 51.8593C54.4448 49.9479 57.1644 50.7182 58.7982 51.9451C59.4681 52.4482 59.803 52.6997 60.0001 52.6997C60.1972 52.6997 60.5321 52.4482 61.202 51.9451C62.8357 50.7182 65.5554 49.9479 68.6714 51.8593C72.7608 54.3677 73.6861 62.6432 64.2535 69.6249C62.4568 70.9547 61.5585 71.6196 60.0001 71.6196C58.4417 71.6196 57.5434 70.9547 55.7467 69.6249C46.3141 62.6432 47.2394 54.3677 51.3288 51.8593Z",
    stroke: "#048F09",
    strokeWidth: 3.48592,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2396 59.9998C83.2396 47.165 72.835 36.7604 60.0002 36.7604C47.1654 36.7604 36.7607 47.165 36.7607 59.9998C36.7607 72.8346 47.1654 83.2393 60.0002 83.2393C72.835 83.2393 83.2396 72.8346 83.2396 59.9998Z",
    stroke: "#30A431",
    strokeWidth: 3.48592
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsvg);
export default __webpack_public_path__ + "static/media/handsvg.ccb9a2735dcbc8eebd03342c875bb1fe.svg";
export { ForwardRef as ReactComponent };